'use strict';

// export this package's api
module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.3.6@rc-animate/lib/index.js
 ** module id = 20
 ** module chunks = 0 1
 **/